import { memo } from "react";
import PropTypes from "prop-types";
import ReactECharts from "echarts-for-react";

import TextThemeBarChart from "./TextThemeBarChart";

function TextThemeWebChart({ data, noData }) {
    if (noData) {
        return (
            <TextThemeBarChart
                data={[]}
                noData={noData}
            />
        );
    }

    const rootStyle = getComputedStyle(document.documentElement);
    const primaryBlue = rootStyle.getPropertyValue("--color-blue").trim();
    const nodes = data?.nodes || [];
    const maxLinkValue = Math.max(...(data?.links || []).map((link) => link.value), 1);
    const links = (data?.links || []).map((link) => ({
        ...link,
        lineStyle: {
            color: primaryBlue,
            width: 1 + (link.value / maxLinkValue) * 4,
            opacity: 0.2 + (link.value / maxLinkValue) * 0.6,
            curveness: 0.3,
        },
    }));

    const option = {
        tooltip: {
            formatter: (params) => params.dataType === "edge"
                ? `${params.data.source} - ${params.data.target}<br/>Co-occurrences: ${params.data.value}`
                : `${params.data.name}<br/>Mentions: ${params.data.value}`,
        },
        series: [
            {
                name: "Themes",
                type: "graph",
                layout: "circular",
                left: "10%",
                right: "10%",
                top: "10%",
                bottom: "10%",
                circular: {
                    rotateLabel: true,
                },
                roam: true,
                data: nodes.map((node) => ({
                    ...node,
                    itemStyle: { color: primaryBlue },
                })),
                links,
                label: {
                    show: true,
                    position: "right",
                    formatter: "{b}",
                },
                lineStyle: {
                    color: primaryBlue,
                    curveness: 0.3,
                },
                emphasis: {
                    focus: "adjacency",
                },
            },
        ],
    };

    return (
        <div className="tta-web-chart">
            <ReactECharts
                option={option}
                style={{ height: "100%", width: "100%" }}
            />
        </div>
    );
}

TextThemeWebChart.propTypes = {
    data: PropTypes.shape({
        nodes: PropTypes.array,
        links: PropTypes.array,
    }),
    noData: PropTypes.bool,
};

export default memo(TextThemeWebChart);
